import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { useSocialList } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminSocialCreate = () => {
    const socials = useSocialList();

    const validateForm = (values) => {
        const errors: any = {};
        if (values?.company && values?.contact) {
            errors.company = {
                message: "Only a company or contact can be selected",
                args: {}
            }
            errors.contact = {
                message: "Only a company or contact can be selected",
                args: {}
            }
        }
        return errors;
    }

    return (
        <Create>
            <SimpleForm validate={ validateForm }>
                <SelectInput
                    name="platform"
                    source="platform"
                    choices={ socials }
                    optionValue="id"
                    validate={[required()]}
                />
                <TextInput name="url" source="url" validate={[required()]} />
                <ReferenceInput source="contact" reference="people">
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <ReferenceInput source="company" reference="companies">
                    <SelectInput optionText="name" />
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}